// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCacheToolType, SelectionModeEnum } from '../DataCacheToolEnums';
import { DataCacheTool } from '../DataCacheTool';
export class VerticalLineDataCacheTool extends DataCacheTool {
    /**
     * Constructor for VerticalLineDataCacheTool
     */
    constructor() {
        super();
        this.ToolType = DataCacheToolType.VerticalLine;
        this.InitPoints(1);
    }
    /**
     * Initializes the block for the tool
     */
    InitBlock() {
        super.InitBlock();
        this.SelectionMode = SelectionModeEnum.X;
    }
    /**
     * Gets the minimum points count required for the tool
     * @returns {number} - Minimum points count
     */
    MinPointsCount() {
        return 1;
    }
    /**
     * Gets the maximum points count required for the tool
     * @returns {number} - Maximum points count
     */
    MaxPointsCount() {
        return 1;
    }
}
